import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#000000',
        fontFamily:'Helvetica-Bold',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
        fontSize: 10
    },
    description: {
        width: '45%',
        borderRightColor: borderColor,
        textAlign: 'left',
        textIndent:'8px',
        fontFamily:'Helvetica-Bold',
        borderRightWidth: 1,
    },
    rate: {
        width: '17%',
        borderRightColor: borderColor,
        fontFamily:'Helvetica-Bold',
        borderRightWidth: 1,
    },
    qty: {
        width: '8%',
        borderRightColor: borderColor,
        fontFamily:'Helvetica-Bold',
        borderRightWidth: 1,
    },
    discount: {
        width: '13%',
        borderRightColor: borderColor,
        fontFamily:'Helvetica-Bold',
        borderRightWidth: 1,
    },
    amount: {
        fontFamily:'Helvetica-Bold',
        textAlign: 'right',
        paddingRight:'8px',
        width: '17%'
    },
  });

  const ProposalTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.description}>Descrição</Text>
        <Text style={styles.rate}>Preço unit.</Text>
        <Text style={styles.qty}>Qtd</Text>
        <Text style={styles.discount}>Desconto</Text>
        <Text style={styles.amount}>Subtotal</Text>
    </View>
  );
  
  export default ProposalTableHeader